import React from 'react'
import { HttpErrorProps } from '../../../hooks/useHttpError'
import { ErrorCodes } from '../../../model'
import { ApiError } from '../specific/api/apiError'
import { BalanceError } from '../specific/balance/balanceError'
import { GlobalError } from '../specific/global/globalError'
import { NotFoundError } from '../specific/notFound/notFoundError'
import { TimeoutError } from '../specific/timeout/timeoutError'
import { UnauthorizedError } from '../specific/unauthorized/unauthorizedError'

export interface GenericErrorProps extends HttpErrorProps {}

export const GenericError: React.FC<any> = ({ ...props }) => {
  const getSuitableErrorImplementation = (
    errorCode: ErrorCodes | string | undefined
  ): JSX.Element | null => {
    console.log(errorCode)
    switch (errorCode) {
      case 'ECONNABORTED':
      case '408':
      case '504': {
        return <TimeoutError onRefresh={props.onRefresh}></TimeoutError>
      }
      case ErrorCodes.UNAUTHORIZED: {
        return <UnauthorizedError {...props}></UnauthorizedError>
      }
      case ErrorCodes.NOT_FOUND: {
        return <NotFoundError {...props}></NotFoundError>
      }
      case ErrorCodes.SERVER_ERROR: {
        return <GlobalError {...props}></GlobalError>
      }
      case ErrorCodes.QUEUE_PENDING_OPERATIONS: {
        return <BalanceError {...props}></BalanceError>
      }
      case undefined: {
        return null
      }
      default: {
        return <ApiError onRefresh={props.onRefresh} onReportError={props.onReportError}></ApiError>
      }
    }
  }

  return getSuitableErrorImplementation(props.errorCode)
}
